export default __webpack_public_path__ + "locales/sr-Cyrl-RS/SingleSignOn.json?hash=95d707d2b9e0c15c1f9b76e5abee6f67";